export const isValidPeriodHidden = (data: { endCycleEndDate: string | null; startCycleEndDate: string | null }[]) =>
  (data ?? []).every(
    (item) => item.endCycleEndDate === data[0].endCycleEndDate && item.startCycleEndDate === data[0].startCycleEndDate
  );
